import TemplatesContainer from "@/features/templates/containers/templates-container";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/templates")({
  component: TemplatesContainer,
});
